module.exports = {
      id: "depositMoneyError-usage",
      viewBox: "0 0 156 114",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#depositMoneyError",
      toString: function () {
        return this.url;
      }
    }